import React from 'react';
import Button from 'src/components/Button';
import CategoryPill from 'src/components/CategoryPill/CategoryPill';
import './BulkWalkthroughSummary.scss';

interface IWalkthroughSummaryItem {
  id: string;
  title: string;
  description: string;
  walkthroughType: string;
  walkthroughName: string;
  permissions: string;
  suiteId: string;
  status: string;
  totalChecklist: number;
  walkthroughChecklistItems: Array<{
    id: string;
    description: string;
    ischecked: boolean;
  }>;
}

interface IWalkthroughSummaryItemProps {
  walkthrough: IWalkthroughSummaryItem;
  index: number;
}

const WalkthroughSummaryItem = ({
  walkthrough,
  index,
}: IWalkthroughSummaryItemProps) => {
  return (
    <div className="walkthrough-summary-item">
      <div className="walkthrough-item-header">
        <div className="walkthrough-item-number">#{index + 1}</div>
        <div className="walkthrough-item-details">
          <h4 className="walkthrough-item-title">{walkthrough.title}</h4>
          <p className="walkthrough-item-description">
            {walkthrough.description}
          </p>
        </div>
        <div className="walkthrough-item-meta">
          <CategoryPill
            text={walkthrough.status}
            color="#6b7280"
            textColor="white"
            size="small"
            centerText={true}
          />
          <CategoryPill
            text={walkthrough.walkthroughType}
            color="#9ca3af"
            textColor="white"
            size="small"
            centerText={true}
          />
        </div>
      </div>
      <div className="walkthrough-item-info-grid">
        <div className="walkthrough-item-info-item">
          <span className="walkthrough-item-label">Suite ID:</span>
          <span className="walkthrough-item-value">{walkthrough.suiteId}</span>
        </div>
        <div className="walkthrough-item-info-item">
          <span className="walkthrough-item-label">Permissions:</span>
          <span className="walkthrough-item-value">
            {walkthrough.permissions}
          </span>
        </div>
        <div className="walkthrough-item-info-item">
          <span className="walkthrough-item-label">Checklist Items:</span>
          <span className="walkthrough-item-value">
            {walkthrough.walkthroughChecklistItems?.length || 0}
          </span>
        </div>
      </div>
      {walkthrough.walkthroughChecklistItems &&
        walkthrough.walkthroughChecklistItems.length > 0 && (
          <div className="walkthrough-item-checklist">
            <h5>Checklist Items:</h5>
            <ul>
              {walkthrough.walkthroughChecklistItems.map((item) => (
                <li key={item.id}>{item.description}</li>
              ))}
            </ul>
          </div>
        )}
    </div>
  );
};

interface IBulkWalkthroughsSummaryProps {
  walkthroughs: IWalkthroughSummaryItem[];
  onClose: () => void;
}

const BulkWalkthroughsSummary = ({
  walkthroughs,
  onClose,
}: IBulkWalkthroughsSummaryProps) => {
  const totalWalkthroughs: number = walkthroughs.length;

  return (
    <div className="bulk-walkthroughs-summary">
      <div className="bulk-summary-header">
        <div className="bulk-summary-success-icon">
          <svg
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="12" cy="12" r="10" fill="#10B981" />
            <path
              d="M9 12l2 2 4-4"
              stroke="white"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
        <h3 className="bulk-summary-title">
          Walkthroughs Created Successfully!
        </h3>
        <p className="bulk-summary-stats">
          You bulk added the following <strong>{totalWalkthroughs}</strong>{' '}
          walkthrough
          {totalWalkthroughs !== 1 ? 's' : ''}
        </p>
      </div>
      <div className="bulk-summary-content">
        <div className="bulk-summary-list">
          {walkthroughs.map(
            (walkthrough: IWalkthroughSummaryItem, index: number) => (
              <WalkthroughSummaryItem
                key={walkthrough.id}
                walkthrough={walkthrough}
                index={index}
              />
            )
          )}
        </div>
      </div>
      <div className="bulk-summary-actions">
        <Button color="teal" size="small" label="Done" onClick={onClose} />
      </div>
    </div>
  );
};

export default BulkWalkthroughsSummary;
